import { Button, createStyles, FormControl, Grid, InputLabel, makeStyles, TextField, Theme as AugmentedTheme } from '@material-ui/core';
import { CustomInputMappingField, JsonDataType } from '@tuqqi/common';
import { FormContext } from '../../store/formContext';
import React, { useState, useContext, useEffect, useMemo } from 'react';
import CustomInput from '../CustomInput';
import TitleIcon from '@material-ui/icons/Title';
import IconField from '../CustomInput/inputIcon';
import RenderAttachment from '../Attachment';
import { useFilterConditionField } from './useConditionFields';
import { FileFieldActions } from '../CustomInput/Inputypes/File';
import { InputLocation } from '../CustomInput/Inputypes/Location/Location';
import { ILocation } from '../CustomInput/Inputypes/Location/locationHelpers';
declare global {
    interface Window {
        grecaptcha: any;
    }
}
interface IProps {
    inputValues: JsonDataType
    businessIdValue?: string
    titleValue: string
    allowUploadFiles?: boolean
    withLocation?: boolean
    location: ILocation | null
    setLocation: (l: ILocation | null) => void
    handleSubmit: () => void,
    getCalculatedFields: (data: JsonDataType) => JsonDataType,
    fieldChanged: (value: string | string[], sourceField: string, isBusinessId: boolean, fieldType?: string) => void,
    titleChanged: (value: string) => void,
    inputFields: Array<CustomInputMappingField>,
    signature: string,
    policy: string,
    getUploadFiles: (fileData: []) => void,
    removeUploadFile: (fileDataKey: string) => void,
    addSignature: (fileData: any) => void,
    attachments: any[]
    isAutomaticField: boolean
    isRtl: boolean
}

const useStyles = makeStyles((theme: AugmentedTheme) => createStyles({
    container: {
        width: '100%',
        padding: 4,
    },
    fieldWrapper: {
        width: '100%',
    },
    inputHolder: {
        paddingLeft: '5%',
        width: '100%',
        // direction: 'rtl',
        textAlign: 'right'
    },
    buttonSubmit: {
        marginTop: 50,
        backgroundColor: 'rgb(103, 58, 183)',
        width: 122,
        textTransform: 'capitalize' as 'capitalize',
        fontSize: 14,
        fontWeight: 500,
    },
    field: {
        width: '100%',
    },
    captchaHolder: {
        marginTop: 40,
    },
    captcha: {
        width: 20,
        height: 20,
    },
    rtlSend: {
        marginRight: 0,
        marginLeft: 'auto'
    },
    //@ts-ignore
    inputLabel: theme.inputLabel,
    //@ts-ignore
    formControl: theme.formControl
}))

export default function Form({ titleValue, location, setLocation, withLocation, allowUploadFiles, getCalculatedFields, inputValues, businessIdValue, handleSubmit, inputFields, fieldChanged, titleChanged, signature, policy, getUploadFiles, removeUploadFile, isAutomaticField,isRtl, addSignature, attachments }: IProps) {
    const classes = useStyles();

    const [titleValueField, setTitleValueField] = useState<string>('');
    const [vals, setVals] = useState<{}>({});
    const [isSending, setIsSending] = useState<boolean>(false);
    const [isFilledSignature, setIsFilledSignature] = useState<boolean>(false);
    const [isAllValidatedFieldsValid, setIsAllValidatedFieldsValid] = useState<boolean>(true)
    const [condition, setCondition ] = useState<string>('');

    const { state } = useContext<any>(FormContext);
    const isLocationField = useMemo(() => inputFields.some(x => x.type === 'location'), [inputFields])

    useEffect(() => {
        setVals(inputValues);
    }, [inputValues])

    useEffect(() => {
        setTitleValueField(titleValue);
    }, [titleValue])
    
    const [filterConditionField] = useFilterConditionField(inputFields, inputValues, businessIdValue)
    const titleFieldChanged = (e: React.ChangeEvent<HTMLInputElement>) => {
        titleChanged(e.currentTarget.value);
        setTitleValueField(e.currentTarget.value);
    }

    const compareFields = (fieldA: CustomInputMappingField, fieldB: CustomInputMappingField): number => {
        if (fieldA.fieldOrder && fieldB.fieldOrder) {
            if (fieldA.fieldOrder < fieldB.fieldOrder) {
                return -1;
            }
            if (fieldA.fieldOrder > fieldB.fieldOrder) {
                return 1;
            }
        }
        return 0;
    }

    useEffect(() => {
        let noValid = [];
        for (let prop in state) {

            if(!state[prop]) {
                noValid.push(state[prop]);
            }
        }

        setIsAllValidatedFieldsValid(!noValid.length);
    }, [state])

    const _fieldChanged = (value: string | string[], sourceField: string, isBusinessId: boolean, fieldType?: string) => {
        let val = value
        if(fieldType === 'signature') {
            if(!value || !Object.keys(value).length) val = ''
            
            //@ts-ignore
            val = value?.fileUid ?? ''

            setIsFilledSignature(!!val)
            !!val && addSignature(value)
        }

        setVals(currentValues => {
            if (!isBusinessId) {
                //@ts-ignore
                currentValues[sourceField] = val;
            }

            const calculatedData = getCalculatedFields(currentValues)

            return {...currentValues, ...calculatedData};
        });

        fieldChanged(val, sourceField, isBusinessId, fieldType)
    }

    const addFiles = (sourceField: string, fileData: any[]) => {
        const vals = (inputValues?.[sourceField] ?? []) as string[]

        const keys = fileData.map(x => x.key)
        _fieldChanged([...keys, ...vals], sourceField, false, 'file')
        getUploadFiles(fileData as any)
    }

    const removeFile = (sourceField: string, fileDataKey: string) => {
        const vals = (inputValues?.[sourceField] ?? []) as string[]
        const keys = vals.filter(x => x !== fileDataKey)

        _fieldChanged(keys, sourceField, false, 'file')
        removeUploadFile(fileDataKey)
    }

    const getFileFieldKeys = (sourceField: string) => {
        const vals = inputValues?.[sourceField] ?? []
        return vals as string[]
    }


    const fileFieldActions: FileFieldActions = {
        addFiles,
        getFileFieldKeys,
        removeFile,
        attachments
    }

    const fields = inputFields.sort(compareFields).filter(filterConditionField)
    const sourceFieldsOfFileFields = useMemo(() => fields
        //@ts-ignore
        .filter(x => x.type === 'file')
        .map(x => x.sourceField), [fields])

    const getAllKeysFileFields = () => {
        const keys = sourceFieldsOfFileFields.reduce((accum: string[], cur) => {
            const part = getFileFieldKeys(cur)
            return [...accum, ...part]
        }, [])
        return keys
    }
    
    const mainFiles = attachments.filter(x => !getAllKeysFileFields().includes(x.key))
    const showLocation = isLocationField ? false : withLocation
    return (
        <form onSubmit={(e) => {e.preventDefault(); handleSubmit(); setIsSending(true)}} className={classes.container}>
            <Grid container direction='column'>
                {!isAutomaticField && <FormControl className={classes.formControl}>
                    <Grid container alignItems="center" direction="row" wrap="nowrap">
                        <TitleIcon/>
                        <Grid className={classes.inputHolder}>
                            <InputLabel 
                             style={{ 
                                direction: isRtl ? 'rtl' : 'ltr',
                                textAlign: isRtl ? 'right' : 'left' 
                            }} 
                             htmlFor="Title" className={classes.inputLabel}>Title</InputLabel>
                            <TextField
                             style={{ 
                                direction: isRtl ? 'rtl' : 'ltr',
                                textAlign: isRtl ? 'right' : 'left' 
                            }} 
                             multiline value={titleValueField} id="Title" className={classes.field} placeholder="Title" onChange={titleFieldChanged} name="title" type="text"/>
                        </Grid>
                    </Grid>
                </FormControl>}
                {fields.map((x: CustomInputMappingField) => (
                    <>
                        <FormControl key={x.sourceField} className={`${classes.fieldWrapper} ${classes.formControl}`}>
                            <Grid container alignItems="center"  wrap="nowrap"  style={{flexDirection: isRtl ? 'row-reverse' : "row"}}>
                                {isFilledSignature && x.type === 'signature' ? <div style={{marginTop: -45}}>{<IconField field={x}/>}</div> : <IconField field={x}/>}
                            <CustomInput location={location} setLocation={setLocation} fileFieldActions={fileFieldActions} vals={vals} signature={signature} policy={policy}  setCondition={setCondition} isRtl={isRtl} fieldChanged={_fieldChanged} field={x} />
                            </Grid>
                        </FormControl>
                    </>
                ))}
                {!!showLocation && <FormControl className={classes.formControl}>
                    <Grid container alignItems="center" direction="row" wrap="nowrap">
                        <InputLocation isRtl={isRtl} location={location} setLocation={setLocation}  />
                    </Grid>
                </FormControl>}
                {!!allowUploadFiles && <FormControl className={classes.formControl}>
                    <Grid container alignItems="center" direction="row" wrap="nowrap">
                        <RenderAttachment required={false} attachments={mainFiles} signature={signature} policy={policy} getUploadFiles={getUploadFiles} removeUploadFile={removeUploadFile}/>
                    </Grid>
                </FormControl>}
                <div
                    className="g-recaptcha"
                    data-sitekey="6LdZrBwcAAAAAOxKnSN_re2ZO6tkIJ-uM0Tej5kF"
                    data-size="invisible"
                ></div>
                <Button type="submit" variant="contained" color="primary" disabled={isSending || !isAllValidatedFieldsValid} className={`${classes.buttonSubmit} ${isRtl ? classes.rtlSend : ''}`}>Send</Button>
            </Grid>
        </form>
    );
}